import * as moment from 'moment';

import {camelCase} from '../../../shared';

export class DatasetField {
   name:string;
   label:string;
   hidden:boolean;
   excludeInParentRows:boolean;
   hideInParentRows:boolean;
   excludeInSubRows:boolean;
   hideInSubRows:boolean;
   excludeInHeader:boolean;
   colSpan:number;
   subrowColSpan:number;
   sum:boolean;
   type:string;
   sort:string;
   parentLabel:string;
   parentColSpan:number;

   constructor(field:any) {
      this.name = camelCase(field.name);
      this.label = field.label;
      this.hidden = field.hidden;
      this.excludeInParentRows = field.excludeInParentRows;
      this.hideInParentRows = field.hideInParentRows;
      this.excludeInSubRows = field.excludeInSubRows;
      this.hideInSubRows = field.hideInSubRows;
      this.excludeInHeader = field.excludeInHeader;
      this.colSpan = field.colSpan;
      this.subrowColSpan = field.subRowColSpan;
      this.sum = field.sum;
      this.type = field.type;
      this.sort = field.sort;
      this.parentLabel = field.parentLabel;
      this.parentColSpan = field.parentColSpan;
   }

   private numberSort() {
      return (a, b) => {
         var v1 = a[this.name],
            v2 = b[this.name];
         if (this.sort === 'asc') {
            return v1 - v2;
         } else {
            return v2 - v1;
         }
      }
   }

   private dateSort() {
      return (a, b) => {
         var d1 = moment(a[this.name]).valueOf(),
            d2 = moment(b[this.name]).valueOf();
         if (this.sort === 'asc') {
            return d1 - d2;
         } else {
            return d2 - d1;
         }
      }
   }

   private stringSort() {
      return (a, b) => {
         var v1 = (this.sort === 'asc') ? a[this.name] : b[this.name];
         var v2 = (this.sort === 'asc') ? b[this.name] : a[this.name];
         v1 = v1 || '';
         v2 = v2 || '';
         return v1.trim().localeCompare(v2.trim());
      }
   }

   private boolSort() {
      return (a, b) => {
         var v1 = (this.sort === 'asc') ? a[this.name] : b[this.name];
         return !v1 ? -1 : 1;
      }
   }

   getSortFn() {
      switch(this.type) {
         case 'number':
            return this.numberSort();
         case 'time':
         case 'date':
         case 'datetime':
            return this.dateSort();
         case 'bool':
            return this.boolSort();
         default:
            return this.stringSort();
      }
   }
}
